import { STAFFING_PRIORIRY_ZONES_ALIASES } from 'domain/shared/staffing';

export const CHANGE_STAFFING_COORDINATOR = 'DELIVERY_PROJECT_CHANGE_STAFFING_COORDINATOR';
export const VIEW_STAFFING_DASHBOARD = 'DELIVERY_PROJECT_VIEW_STAFFING_DASHBOARD';

export const STAFFING_RISK_STATUS_DISPLAY = {
  ACTIVE: 'Active',
  CLOSED: 'Closed',
};

export const ZONE_LABELS = {
  [STAFFING_PRIORIRY_ZONES_ALIASES.SAFE]: 'Safe',
  [STAFFING_PRIORIRY_ZONES_ALIASES.MONITORING]: 'Monitoring',
  [STAFFING_PRIORIRY_ZONES_ALIASES.CRITICAL]: 'Critical',
};

export const ZONE_DESCRIPTIONS = {
  [STAFFING_PRIORIRY_ZONES_ALIASES.SAFE]: 'Projects running smoothly without issues',
  [STAFFING_PRIORIRY_ZONES_ALIASES.MONITORING]: 'Projects with minor issues that need attention',
  [STAFFING_PRIORIRY_ZONES_ALIASES.CRITICAL]: 'Projects with significant issues requiring immediate action',
};
